import "./tasks.css"
import React, {useEffect, useState} from "react";
import {usePumpStore} from "../../store/pumpStore";
import taskImg from "../../pages/task/task.png";
import arrow from "../../pages/task/arrow.png";
import axios, {all} from "axios";
import SlotCounter from "react-slot-counter";
import shield from "../../pages/task/shield.png";
import heal from "../../pages/task/heal.png";
import ConfettiExplosion from "react-confetti-explosion";
import {Chests} from "./chests/chests";
import { initHapticFeedback } from "@telegram-apps/sdk-react";
import {levels} from "../../helpers/levelHelpers";
import coin from "../../assets/coin.svg";


const largeProps = {
    force: 0.6,
    duration: 2000,
    particleCount: 200,
    width: 2500,
    colors: ['#041E43', '#1471BF', '#5BB4DC', '#FC027B', '#66D805'],
};


export const TaskScreen = () => {
    const {selectedAnswer, status, task, setIsExploding, setWinAmountClass, equity, setEquity, setTaskNumber, tasksCount, setTasksCount, balance, setBalance, equityClass, equityTitleClass, correctAnswer, setCorrectAnswer, resetProfile,
        taskNumber, answerChosen, userId, setTask, setSelectedAnswer, setAnswerChosen, setWinAmount, setStatus, setEquityClass, setEquityTitleClass, screenStatus, setScreenStatus, winAmount, winAmountClass, isExploding, extTime, artifacts,
        showChests, setShowChests, chestsType, setChestsType, appInitData, level, setLevel, setScreenLayout, setShowHeal, showHeal, showShield} = usePumpStore()
    const [time, setTime] = useState(extTime)
    const [allowSelection, setAllowSelection] = useState(true)
    const hapticFeedback = initHapticFeedback();

    const setTimer = () => {
        let timer = setInterval(() => {
            setTime((time) => {
                if (time === 0) {
                    clearInterval(timer);
                    window.location.reload()
                    return 0;
                } else return time - 1;
            });
        }, 1000);
    }

    const requestTask = () => {
        axios.post('https://pump.stt.market/api/get_task', {'chat_id': appInitData.user.id}).then((res) => {
            console.log(res)
            let task = res.data
            task.image = 'https://pump.stt.market' + task.image
            setTask(res.data)
            if (task.adv) {
                setAllowSelection(false)
            }
        })
    }

    useEffect(() => {
        if (userId !== 0 && screenStatus !== 'locked') {
            requestTask()
        }
        if (screenStatus === 'locked') {
            setTimer()
        }

    }, [userId]);

    useEffect(() => {
        setTime(extTime)
    }, [extTime]);

    useEffect(() => {
        if (status === 'wait') {
            axios.post('https://pump.stt.market/api/fetch_user', {'chat_id': appInitData.user.id}).then((res) => {
                if (res.data.data.status === 'locked') {
                    setScreenStatus('locked')
                    setStatus('wait')
                    setTime(res.data.data.timeToOpen)
                }
            })
        }
    }, [status]);

    function numberWithCommas(x) {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    function selectAnswer(num) {
        if (allowSelection) {
            setSelectedAnswer(num)
            setAnswerChosen(true)
        }
    }

    const changeAllowance = () => {
        setTimeout(function () {
            setAllowSelection(true)
        }, 2000)
    }

    const skipAnswer = () => {
        let eqi = 0.0
        setStatus('skip')
        axios.post('https://pump.stt.market/api/skip', {'chat_id': appInitData.user.id}).then((res) => {
            const eq = parseFloat(equity)
            setEquity(parseFloat(eq))
            eqi = eq
            const tn = taskNumber + 1
            if (tn <= 12) {
                setTaskNumber(tn)
            }
            if (taskNumber === 12) {
                setStatus('wait')
                setScreenStatus('locked')
                setEquityTitleClass('eqdiv _done')
                setEquityClass('text-wrapper _small')
                setTimeout(function () {
                    setEquityClass('text-wrapper _small _eq')
                }, 150)
                setTimeout(function () {
                    setEquityClass('text-wrapper _small _eq _fin')
                    if (eqi < 0) {
                        eqi = 0
                    }
                    const bal = balance + eqi
                    setBalance(bal)
                    console.log(bal)
                    setEquity(0.0)
                },350)
                let timer = setInterval(() => {
                    setTime((time) => {
                        if (time === 0) {
                            clearInterval(timer);
                            window.location.reload()
                            return 0;
                        } else return time - 1;
                    });
                }, 1000);
            } else {
                setStatus('idle')
                setWinAmountClass('win-amount')
                setSelectedAnswer('')
                setAnswerChosen(false)
                setCorrectAnswer('')
                requestTask()
            }
        })
    }

    const confirmAnswer = () => {
        let eqi = 0.0
        if (selectedAnswer !== '' && task.options.includes(selectedAnswer)) {
            axios.post('https://pump.stt.market/api/answer', {'chat_id': appInitData.user.id, 'answer': selectedAnswer}).then((res) => {
                const data = res.data
                console.log(data)
                if (data.status === 200) {
                    hapticFeedback.notificationOccurred('success');
                    window.scrollTo(0, 0)
                    setWinAmount('+ ' + data.price)
                    setStatus('success')
                    setIsExploding(true)
                    setCorrectAnswer(selectedAnswer)
                    setTimeout(function (){
                        setWinAmountClass('win-amount _small')
                    },1000)
                    setTimeout(function (){
                        setWinAmountClass('win-amount _small _eq')
                    },1150)
                    setTimeout(function (){
                        setWinAmountClass('win-amount _small _eq _fin')
                    },1350)
                    setTimeout(function () {
                        const eq = parseFloat(equity) + parseFloat(data.price)
                        console.log(equity)
                        console.log(data.price)
                        console.log(eq)
                        setEquity(parseFloat(eq))
                        eqi = eq
                        const tn = taskNumber + 1
                        if (tn <= 12) {
                            setTaskNumber(tn)
                        }
                        if ([5, 11].includes(tn)) {
                            setShowChests(true)
                        }
                        const total = tasksCount + 1
                        setTasksCount(total)
                        let targetLevel = level + 1
                        const targetTasks = levels[targetLevel].count
                        if (total >= targetTasks) {
                            setLevel(targetLevel)
                            setScreenLayout('levelup')
                        }
                    }, 1350)
                    setTimeout(function () {
                        if (taskNumber === 12) {
                            setEquityTitleClass('eqdiv _done')
                            setEquityClass('text-wrapper _small')
                            setTimeout(function () {
                                setEquityClass('text-wrapper _small _eq')
                            }, 150)
                            setTimeout(function () {
                                setEquityClass('text-wrapper _small _eq _fin')
                                if (eqi < 0) {
                                    eqi = 0
                                }
                                const bal = parseFloat(balance) + eqi
                                setBalance(bal.toFixed(2))
                                console.log(bal)
                                setEquity(0.0)
                                setStatus('wait')
                                setScreenStatus('locked')
                            },350)
                            let timer = setInterval(() => {
                                setTime((time) => {
                                    if (time === 0) {
                                        clearInterval(timer);
                                        window.location.reload()
                                        return 0;
                                    } else return time - 1;
                                });
                            }, 1000);
                        } else {
                            setStatus('idle')
                            setWinAmountClass('win-amount')
                            setSelectedAnswer('')
                            setCorrectAnswer('')
                            setAnswerChosen(false)
                            requestTask()
                        }

                    }, 2000)
                }
                else if (data.status === 202) {
                    hapticFeedback.notificationOccurred('error');
                    window.scrollTo(0, 0)
                    setWinAmount('- ' + task.price)
                    setCorrectAnswer(data.answer)
                    if (artifacts.includes('heal')) {
                        setShowHeal(true)
                    }
                    setStatus('fail')
                    setTimeout(function (){
                        setWinAmountClass('win-amount _small')
                    },1000)
                    setTimeout(function (){
                        setWinAmountClass('win-amount _small _eq')
                        setShowHeal(false)
                    },1150)
                    setTimeout(function (){
                        setWinAmountClass('win-amount _small _eq _fin')
                    },1350)
                    setTimeout(function () {
                        setSelectedAnswer(0)
                        let eq = 0
                        if (!artifacts.includes('heal')) {
                            eq = parseFloat(equity) - parseFloat(task.price)
                        } else {
                            eq = parseFloat(equity)
                        }
                        console.log(eq)
                        setEquity(parseFloat(eq))
                        eqi = eq
                        const tn = taskNumber + 1
                        if (tn <= 12) {
                            setTaskNumber(tn)
                        }

                        if ([5, 11].includes(tn)) {
                            setShowChests(true)
                        }

                    }, 1350)
                    setTimeout(function () {
                        console.log(taskNumber)
                        if (taskNumber === 12) {
                            setEquityTitleClass('eqdiv _done')
                            setEquityClass('text-wrapper _small')
                            setTimeout(function () {
                                setEquityClass('text-wrapper _small _eq')
                            }, 150)
                            setTimeout(function () {
                                setEquityClass('text-wrapper _small _eq _fin')
                                if (eqi < 0) {
                                    eqi = 0
                                }
                                const bal = parseFloat(balance) + eqi
                                setBalance(bal.toFixed(2))
                                console.log(bal)
                                setEquity(0.0)
                                setStatus('wait')
                                setScreenStatus('locked')
                            },350)
                            let timer = setInterval(() => {
                                setTime((time) => {
                                    if (time === 0) {
                                        clearInterval(timer);
                                        window.location.reload()
                                        return 0;
                                    } else return time - 1;
                                });
                            }, 1000);
                        } else {
                            setStatus('idle')
                            setWinAmountClass('win-amount')
                            setSelectedAnswer('')
                            setAnswerChosen(false)
                            setCorrectAnswer('')
                            requestTask()
                        }

                    }, 2000)
                }
            })
        }
    }

    return (
        <div className={"task"}>
            {status !== 'wait' &&
                <React.Fragment>
                    {!showChests
                        ? <React.Fragment>
                            <div className={`${status === 'idle' && 'animate__animated animate__zoomIn'}`}>

                                {(task.options.length > 0) &&
                                    <div className={"task__info"}>
                                        <div className="task__info-number">{taskNumber}/12</div>
                                        <div>
                                            <div className={equityTitleClass}>equity</div>
                                            <div className={equityClass} style={{color: equity >= 0 ? '#38e476' : '#EF7B99'}}>{equity >= 0 ? '+' : ''} <SlotCounter value={numberWithCommas(equity)} /></div>
                                        </div>
                                        <div className="task__info-price"><img src={coin} alt={''} style={{height: 26, marginRight: 5}}/> {task.price}</div>
                                    </div>
                                }

                                {task.type === 'image'
                                    ? <div className="task__holder">
                                        <img className="task__holder-item" alt="Element" src={task.image} />
                                    </div>
                                    : <React.Fragment>
                                        {task.type === 'video'
                                            ? <div className="task__holder">
                                                <video className="task__holder-item" key={task.image} preload={'auto'} controls>
                                                    <source src={task.image+'#t=0.1'} type={'video/mp4'}/>
                                                </video>
                                            </div>
                                            : <React.Fragment>
                                                {task.type === 'link'
                                                    ? <div className="art-wrapper">
                                                        <a href={task.link} target={'_blank'} rel={'noreferrer'} onClick={changeAllowance}>Смотреть</a>
                                                    </div>
                                                    : ''
                                                }
                                            </React.Fragment>
                                        }
                                    </React.Fragment>
                                }
                                {task.type !== 'text'
                                    ? <div className="task__title">{task.title}</div>
                                    : <div className="art-wrapper"><div className="task__title">{task.title}</div></div>
                                }
                            </div>
                            <div className="task__options">
                                {task.options.map((item, index) => (
                                    <div key={index} className={`button ${status === 'idle' && 'animate__animated animate__fadeInUp animate__faster animate__delay-'+ (0.5 * index).toString().replace('.', '') + 's'} ${selectedAnswer === item ? '_selected' : ''} ${correctAnswer === item && '_correct'}`} onClick={() => selectAnswer(item)}>
                                        {item}
                                    </div>
                                ))}
                            </div>
                            {task.options.length !== 0 &&
                                <div className={`task__actions ${(status !== 'idle' || !artifacts.includes('skip') || !allowSelection)  && '_empty'}`}>
                                    {(status === 'idle' && artifacts.includes('skip') && allowSelection) && <div className={"task__actions-empty"}></div>}
                                    <div className={answerChosen ? 'task__actions-confirm _selected' : `${status === 'idle' ? 'task__actions-confirm animate__animated animate__fadeInDown animate__delay-2s' : 'globally_hidden'}`} onClick={confirmAnswer}>
                                        <div className="pump">PUMP</div>
                                    </div>
                                    <img className={`${(status === 'idle' && artifacts.includes('skip') && allowSelection) ? 'task__actions-skip animate__animated animate__fadeInDown animate__delay-25s' : 'globally_hidden'}`} alt="Arrow" src={arrow} onClick={skipAnswer} />
                                </div>
                            }
                        </React.Fragment>
                        : <Chests />
                    }
                </React.Fragment>
            }


            {status === 'success'
                ? <React.Fragment>
                    <div className={"status _success"}>
                        <div className={'success-amount ' + winAmountClass}>{winAmount}</div>
                        {isExploding && <ConfettiExplosion {...largeProps} />}
                    </div>
                </React.Fragment>
                : <React.Fragment>
                    {status === 'skip'
                        ? <React.Fragment>
                            <div className={"status _success"}>
                                <img src={arrow} alt={''} style={{top: '200px'}} className={"animate__animated animate__heartBeat"}/>
                            </div>
                        </React.Fragment>
                        : <React.Fragment>
                            {status === 'fail'
                                ? <React.Fragment>
                                    <div className={"status _fail animate__animated animate__fadeIn animate__faster"}>
                                        {showHeal && <img src={heal} alt={''} className={"animate__animated animate__bounceInDown"} style={{top: 220, width: 90, left: 'calc(50% - 45px)', display: "block"}}/>}
                                        {showShield && <img src={shield} alt={''} className={"animate__animated animate__bounceInDown"} style={{top: 200, width: 90, left: 'calc(50% - 45px)', display: "block"}}/>}
                                        <div className={winAmountClass}>{winAmount}</div>
                                        {/*<img src={fail} alt={''}/>*/}
                                    </div>
                                </React.Fragment>
                                : <React.Fragment>
                                    {status === 'shield'
                                        ? <React.Fragment>
                                            <div className={"status _fail animate__animated animate__fadeIn animate__faster"}>
                                                <img src={shield} alt={''} className={"animate__animated animate__bounceInDown"} style={{top: 220, width: 90, left: 'calc(50% - 45px)'}}/>
                                                <div className={winAmountClass}>- {winAmount}</div>
                                                {/*<img src={fail} alt={''} />*/}
                                            </div>
                                        </React.Fragment>
                                        : <React.Fragment>
                                            {status === 'wait'
                                                ? <React.Fragment>
                                                    <div className={"status _fail _wait"}>
                                                        <p>
                                                            Новые задания<br/>появятся через<br/><span style={{fontSize: 42}}>{`${Math.floor(time / 3600)}`.padStart(2, 0)}:{`${Math.floor((time % 3600) / 60)}`.padStart(2, 0)}:{`${time % 60}`.padStart(2, 0)}</span>
                                                        </p>
                                                    </div>
                                                </React.Fragment>
                                                : <React.Fragment></React.Fragment>
                                            }
                                        </React.Fragment>
                                    }
                                </React.Fragment>
                            }
                        </React.Fragment>
                    }
                </React.Fragment>
            }
        </div>
    )
}